import axios from 'axios';
import { getStoredData } from '../../JsonFiles/fetchData';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import IntroTemplate from '../../components/IntroTemplate/IntroTemplate'; // Adjust the path as per your product structure
import SmallDescription from "../../components/SmallDescription/SmallDescription";
import ViewSlider from '../../components/ViewSlider/ViewSlider';
import ProjectImageScroll from '../../components/ProjectImageScroll/ProjectImageScroll';
import RedirectToPage from '../../components/RedirectToPage/RedirectToPage'; // Adjust the path
import KeyPoints from '../../components/KeyPoints/KeyPoints';

const ProductPage = () => {
  const { id } = useParams(); // Get the product ID from the URL
  const data = getStoredData()?.["6"] ?? {};
  const [product, setProduct] = useState(null); // State to store product details
  const [project, setProject] = useState(null); // State to store project details
  const [error, setError] = useState(null); // State for handling errors


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/projects');
        setProject(response.data);
      } catch (err) {
        console.error('Error fetching projects:', err);
      }
    };
  
    fetchProducts();
  }, []);

  useEffect(() => {
    // Fetch product details using the ID from the URL
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`https://shahbad-enterprises-backend.vercel.app/products/${id}`);
        setProduct(response.data);
      } catch (err) {
        console.error('Error fetching product details:', err);
        setError('Failed to fetch product details.');
      }
    };

    if (id) {
      fetchProduct();
    }
  }, [id]);

  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }

  if (!product) {
    return <div>Loading product details...</div>; 
  }

  return (
    <div>
      <IntroTemplate 
        logo={product.icon} 
        title={product.title} 
        image={product.photo?.[0]?.url} 
      />
      <SmallDescription title={product.name} details={product.details}/>
      <KeyPoints points={product.keypoints}/>
      <ProjectImageScroll data={product.photo} title={data.imageHeading} detail={data.imageDetails}/>
      <ViewSlider
        title={data.ViewTitle}
        link={data.ViewLink}
        text={data.ViewText}
        items={project}
      />
      <RedirectToPage 
        link={data.RedirectLink} 
        title={data.RedirectTitle} 
        image={data.RedirectImage} 
        details={data.RedirectDetails} 
        ButtonText={data.RedirectButtonText}
      />
    </div>
  );
};

export default ProductPage;
